import request from '@/utils/request'

// 获取验证码
export function loginCode(phone) {
  return request({
    url: `/api/loginCode?phoneNumber=${phone}`,
    method: 'get'
  })
}
// 验证码登录
export function smsLogin(data) {
  return request({
    url: '/api/smsLogin',
    method: 'post',
    data
  })
}

// 密码登录
export function pwdLogin(data) {
  return request({
    url: '/api/pwdLogin',
    method: 'post',
    data
  })
}
// 修改密码
export function changePwd(data) {
  return request({
    url: '/api/member/changePwd',
    method: 'post',
    data
  })
}

// 忘记密码
export function forgotPwd(data) {
  return request({
    url: '/api/forgotPwd',
    method: 'post',
    data
  })
}

// 更改密码发送验证码
export function changePwdPhone(data) {
  return request({
    url: `/api/member/changePwdPhone?phoneNumber=${data.phoneNumber}`,
    method: 'get'
  })
}

// 更换手机号发送验证码
export function changePhoneCode(phone) {
  return request({
    url: `/api/member/changePhoneCode?phoneNumber=${phone}`,
    method: 'get'
  })
}

// 更换新手机号
export function changePhone(phone, code) {
  return request({
    url: `/api/member/changePhone?newPhone=${phone}&code=${code}`,
    method: 'get'
  })
}

// 更换手机号发送新手机验证码
export function changeNewPhoneCode(phone) {
  return request({
    url: `/api/member/changeNewPhoneCode?phoneNumber=${phone}`,
    method: 'get'
  })
}

// 验证更换手机号发送验证码
export function validChangePhoneCode(phone, code) {
  return request({
    url: `/api/member/validChangePhoneCode?phoneNumber=${phone}&code=${code}`,
    method: 'get'
  })
}

// 获取会员信息
export function getMemberInfo(phone) {
  return request({
    url: `/api/getMemberInfo`,
    method: 'get'
  })
}

// 退出登录
export function logout() {
  return request({
    url: `/api/logout`,
    method: 'post'
  })
}

// 更换院校

export function saveCollege(params) {
  return request({
    url: `/api/college`,
    method: "get",
    params
  });
}